import { render, staticRenderFns } from "./IcoPathwayContent.vue?vue&type=template&id=b246c570"
import script from "./IcoPathwayContent.vue?vue&type=script&lang=js"
export * from "./IcoPathwayContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports